<script setup lang="ts">
import { X } from 'lucide-vue-next';

defineProps<{
  displayedText: string;
  isTyping: boolean;
  placeholder?: string;
  ghost?: string;
}>();
</script>

<template>
  <div class="mock-join-prod dark clean w-full relative">
    <div class="mock-input-field-prod dark">
      <span v-if="displayedText" class="typed">{{ displayedText }}</span>
      <span v-else-if="!isTyping && placeholder" class="placeholder">
        {{ placeholder }}
      </span>
      <span v-if="ghost" class="ghost">{{ ghost }}</span>
      <span v-if="displayedText || isTyping" class="cursor">|</span>
    </div>
    <div v-if="displayedText || isTyping" class="mock-input-clear-prod dark"><X :size="16" /></div>
  </div>
</template>

<style scoped>
.mock-join-prod.dark.clean { display: flex; background: #18181b; border-radius: 12px; height: 56px; overflow: hidden; border: 1px solid rgba(255,255,255,0.1); padding: 0 20px; align-items: center; }
.mock-input-field-prod.dark { flex-grow: 1; display: flex; align-items: center; font-size: 1rem; color: #fafafa; font-weight: 500; }
.placeholder { color: #52525b; font-style: normal; }
.ghost { opacity: 0.3; }
.cursor { color: #e21b0d; animation: blink 1s step-end infinite; }
@keyframes blink { 50% { opacity: 0; } }
</style>
